export { default } from './ImageCaption';
export type { Props, Props as ImageCaptionProps } from './ImageCaption';
